import angular from "angular";
import ClientDetails from "./ClientDetails";

export default angular.module("sonas.menu", [])
.directive("clientDetails", ClientDetails)
.name;


// WEBPACK FOOTER //
// ./src/Menu/index.js